import React from 'react';

const TermsOfUse = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto">
        <div className="bg-white shadow-lg rounded-lg p-8">
          <h1 className="text-3xl font-bold text-blue-600 border-b-2 border-blue-600 pb-4 mb-6">
            Athena Project Management – User Agreement & Terms of Service
          </h1>
          
          <p className="text-gray-600 italic mb-8">
            Effective Date: January 13, 2026
          </p>
          
          <div className="prose prose-lg max-w-none">
            <p className="mb-6 font-medium">
              This Agreement governs your use of Athena Project Management.
            </p>

            <h2 className="text-2xl font-semibold text-blue-800 mt-8 mb-4">1. Access</h2>
            <ul className="list-disc pl-6 mb-6 space-y-2">
              <li>Accounts are provisioned by organizations</li>
              <li>You are responsible for all activity</li>
              <li>You must follow your organization's policies</li>
            </ul>

            <h2 className="text-2xl font-semibold text-blue-800 mt-8 mb-4">2. Subscriptions & Billing</h2>
            <ul className="list-disc pl-6 mb-6 space-y-2">
              <li>Monthly or annual plans</li>
              <li>Auto-renewal</li>
              <li>Fees non-refundable</li>
              <li>10-day grace period</li>
              <li>Pricing subject to change</li>
            </ul>

            <h2 className="text-2xl font-semibold text-blue-800 mt-8 mb-4">3. Data Ownership</h2>
            <ul className="list-disc pl-6 mb-6 space-y-2">
              <li>You own your data</li>
              <li>You grant Company license to host & process it</li>
              <li>Aggregated anonymized data may be used</li>
            </ul>

            <h2 className="text-2xl font-semibold text-blue-800 mt-8 mb-4">4. Acceptable Use</h2>
            <p className="mb-4">You may not:</p>
            <ul className="list-disc pl-6 mb-6 space-y-2">
              <li>Violate laws</li>
              <li>Upload malware</li>
              <li>Abuse the system</li>
              <li>Reverse engineer</li>
              <li>Interfere with service</li>
            </ul>

            <h2 className="text-2xl font-semibold text-blue-800 mt-8 mb-4">5. Availability</h2>
            <p className="mb-6">
              Service provided "as-is". No uptime guarantees.
            </p>

            <h2 className="text-2xl font-semibold text-blue-800 mt-8 mb-4">6. AI Disclaimer</h2>
            <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4 mb-6">
              <p className="mb-4">AI outputs:</p>
              <ul className="list-disc pl-6 mb-4 space-y-2">
                <li>May be inaccurate</li>
                <li>Are not professional advice</li>
                <li>Used at your own risk</li>
              </ul>
              <p className="font-medium">Company has no liability for AI reliance.</p>
            </div>

            <h2 className="text-2xl font-semibold text-blue-800 mt-8 mb-4">7. Intellectual Property</h2>
            <ul className="list-disc pl-6 mb-6 space-y-2">
              <li>Company owns Athena Project Management platform</li>
              <li>You retain your content</li>
            </ul>

            <h2 className="text-2xl font-semibold text-blue-800 mt-8 mb-4">8. Support Access</h2>
            <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-6">
              <p className="mb-4">You acknowledge:</p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Authorized staff may access accounts</li>
                <li>Only for support/security</li>
                <li>All actions logged</li>
              </ul>
            </div>

            <h2 className="text-2xl font-semibold text-blue-800 mt-8 mb-4">9. Termination</h2>
            <ul className="list-disc pl-6 mb-6 space-y-2">
              <li>Cancel anytime</li>
              <li>Data export available for 30 days</li>
              <li>Data may be deleted after</li>
            </ul>

            <h2 className="text-2xl font-semibold text-blue-800 mt-8 mb-4">10. Limitation of Liability</h2>
            <p className="mb-4 font-medium">Maximum liability:</p>
            <ul className="list-disc pl-6 mb-4 space-y-2">
              <li>Fees paid in last 12 months</li>
            </ul>
            <p className="mb-4">No liability for:</p>
            <ul className="list-disc pl-6 mb-6 space-y-2">
              <li>Indirect damages</li>
              <li>Lost profits</li>
              <li>Data loss</li>
            </ul>

            <h2 className="text-2xl font-semibold text-blue-800 mt-8 mb-4">11. Governing Law & Arbitration</h2>
            
            <h3 className="text-lg font-semibold text-blue-700 mt-4 mb-2">Governing Law</h3>
            <p className="mb-4">
              This Agreement is governed by the laws of the State of Delaware, without regard to conflict of law principles.
            </p>
            
            <h3 className="text-lg font-semibold text-blue-700 mt-4 mb-2">Arbitration Venue</h3>
            <p className="mb-4">
              Any dispute shall be resolved by binding arbitration in the State of Wyoming.
            </p>
            
            <h3 className="text-lg font-semibold text-blue-700 mt-4 mb-2">Class Action Waiver</h3>
            <p className="mb-6">
              All claims must be brought individually.
            </p>

            <h2 className="text-2xl font-semibold text-blue-800 mt-8 mb-4">12. Miscellaneous</h2>
            <ul className="list-disc pl-6 mb-6 space-y-2">
              <li>Force majeure</li>
              <li>Severability</li>
              <li>Entire agreement</li>
              <li>Updates posted online</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsOfUse;
